import { useNavigate } from 'react-router-dom';
import React, { useState, useEffect, Fragment } from 'react';

import { DashboardsBackOffice } from "../../../components/backgrounds/DashboardsBackoffice";
import { HttpRequest } from '../../../services/httpRequest';
import { SuccessAlert } from '../../../components/alerts/successAlert';
import { ErrorAlert } from '../../../components/alerts/errorAlert';
import { roleUser } from '../../../utils/roleUser';
import { APIClient } from '../../../helpers/api_helper';
import * as urlHelper from '../../../helpers/url_helper';

const apiClient = new APIClient();

export function InteresCorrienteConfig(params) {
    const navigate = useNavigate();
    const [messsageAlert, setMessageAlert] = useState("");
    const [isOpenSuccess, setIsOpenSuccess] = useState();
    const [isOpenError, setIsOpenError] = useState();
    const [viewalert, setViewalert] = useState(false);
    const [formData, setFormData] = useState({
        tea: "",
        tasa: "",
        id: ""
    });

    const getInfoRole = async (doc) => {
        try {
            let response = await HttpRequest.getInfoRole(doc);
            return response.message;
        } catch (error) {
            console.log(error);
            return {}
        }
    }

    const getInterest = async () => {
        try {
            let response = await apiClient.get(urlHelper.GET_RATES_CURRENT_INTEREST);
            return response.data?.data;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const updateInterest = async () => {
        try {
            let response = await apiClient.put(urlHelper.UPDATE_RATES_CURRENT_INTEREST + "/" + formData.id, { tasa: formData.tasa });
            return response;
        } catch (error) {
            console.log(error);
            return [];
        }
    }

    const handleOpenAlert = (type, message, isOpen) => {
        if (type === 'success') {
            setMessageAlert(message);
            setIsOpenSuccess(isOpen);
            setViewalert(true);
        }
        if (type === 'error') {
            setMessageAlert(message);
            setIsOpenError(isOpen);
            setViewalert(true);
        }
    }

    const handleClearStateAlert = () => {
        setViewalert(false);
        setMessageAlert("");
        setIsOpenSuccess(false);
        setIsOpenError(false);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const convertPercentageToDecimal = (percentageString) => {
        if (!percentageString) return null;
        const cleanedPercentage = percentageString.replace(',', '.');
        const percentage = parseFloat(cleanedPercentage);

        if (isNaN(percentage) || !isFinite(percentage)) {
            return null;
        }
        return percentage / 100;
    }

    /* Elevar a la potencia  */
    const raiseToPower = (decimalValue, exponent) => {
        return Math.pow(decimalValue, exponent);
    }

    /* Calcula la tasa de usura efectiva mensual */
    const calcularInteresCorrienteTem = (_interesCorrienteTea) => {
        let interesCorrienteTea = Number(_interesCorrienteTea).toFixed(2);
        let interesCorrienteTeaDecimal = convertPercentageToDecimal(interesCorrienteTea);
        let interesCorrienteTem = interesCorrienteTeaDecimal + 1;
        interesCorrienteTem = raiseToPower(interesCorrienteTem, 1 / 12);
        interesCorrienteTem = interesCorrienteTem - 1;
        interesCorrienteTem = interesCorrienteTem * 100;

        if (isNaN(interesCorrienteTem) || !isFinite(interesCorrienteTem)) {
            return null;
        }
        return interesCorrienteTem;
    }

    /* Calcula la tasa de usura efectiva diaria */
    const calcularInteresCorrienteTed = (interesCorrienteTem) => {
        let interesCorrienteTed = interesCorrienteTem / 30;
        if (isNaN(interesCorrienteTed) || !isFinite(interesCorrienteTed)) {
            return null;
        }
        return interesCorrienteTed.toFixed(5);
    }

    const handleChangeTea = (e) => {
        const { name, value } = e.target;
        let interesCorrienteTea = parseFloat(value);

        let interesCorrienteTem = calcularInteresCorrienteTem(interesCorrienteTea);
        let interesCorrienteTed = calcularInteresCorrienteTed(interesCorrienteTem);
        setFormData({
            ...formData,
            tea: interesCorrienteTea,
            tasa: interesCorrienteTed,
        });
    };


    const handleSubmit = async (e) => {
        handleClearStateAlert()
        e.preventDefault();
        if (formData.tasa === "") {
            handleOpenAlert('error', "Debe ingresar una tasa", true);
            return;
        }
        try {
            let response = await updateInterest();
            let status = response.status;
            if (status === 200) {
                handleOpenAlert('success', response.data?.message, true);
            } else {
                handleOpenAlert('error', response.data?.message, true);
            }
        } catch (error) {
            console.log(error);
            handleOpenAlert('error', error.message, true);

        }
        setTimeout(() => {
            handleClearStateAlert()
        }, 6000);

    }

    useEffect(() => {
        let doc = localStorage.getItem('doc');
        if (typeof doc !== 'string') {
            return navigate('/ingresar');
        } else {
            getInfoRole(doc)
                .then(async (infoRole) => {
                    if (infoRole?.error === true) return navigate('/ingresar');
                    if ('user' in infoRole) {
                        let user = infoRole.user;

                        if (user?.roleUser === roleUser.admin) {
                            console.log('User authorized...');
                            let interest = await getInterest();
                            setFormData({
                                tea: interest[0]?.tea, // tasa,
                                tasa: interest[0]?.tasa, // tasa,
                                id: interest[0]?._id // id
                            });
                        } else {
                            alert('No esta autorizado para ver esta página.');
                            setTimeout(() => {
                                return navigate('/ingresar');
                            }, 2000);
                        }
                    } else {
                        return navigate('/ingresar');
                    }
                })
                .catch(e => console.log(e))
        }

    }, [])

    return (
        <Fragment>
            {
                viewalert ?
                    <>
                        <SuccessAlert isOpen={isOpenSuccess} message={messsageAlert}></SuccessAlert>
                        <ErrorAlert isOpen={isOpenError} message={messsageAlert}></ErrorAlert>
                    </>
                    : <></>
            }

            <DashboardsBackOffice
                name={'Admin'}
                balance={0}
                current10={true}
                title={'Interes Corriente'}
                main={
                    <>
                        <form action="#" method="POST">
                            <div className='px-4 mt-3 py-5 bg-white sm:p-6' style={{ borderRadius: '5px' }}>

                                <div className="col-span-8 sm:col-span-4">
                                    <label
                                        htmlFor="tasa"
                                        className="block text-sm font-medium"
                                    >
                                        Tasa efectiva anual
                                    </label>
                                    <div>
                                        <input
                                            value={formData.tea || ''}
                                            onChange={handleChangeTea}
                                            type="number"
                                            name="tea"
                                            id="tea"
                                            maxLength="40"
                                            className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                        />
                                    </div>
                                    <span
                                        className="text-sm"
                                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                                    >
                                        {''}
                                    </span>
                                </div>

                                <div className="col-span-8 sm:col-span-4">
                                    <label
                                        htmlFor="tasa"
                                        className="block text-sm font-medium"
                                    >
                                        Tasa efectiva diaria
                                    </label>
                                    <div>
                                        <input
                                            value={formData.tasa}
                                            onChange={handleChange}
                                            type="text"
                                            name="tasa"
                                            id="tasa"
                                            maxLength="40"
                                            className="py-2 px-4 block w-full border-0 border-b focus:border-purple focus:ring-0 sm:text-base"
                                        />
                                    </div>
                                    <span
                                        className="text-sm"
                                        style={{ color: "#fc3e58", fontStyle: "italic" }}
                                    >
                                        {''}
                                    </span>
                                </div>


                                <div className="md:w-56 pt-3 mt-3">
                                    <button
                                        onClick={handleSubmit}
                                        type="button"
                                        className="w-full flex justify-center py-2 px-4 border border-transparent rounded-full shadow-sm text-xl font-medium text-white bg-green transition duration-300 hover:bg-greenDark focus:outline-none"
                                    >
                                        <div className="flex">
                                            {'Guardar'}
                                            <div className="grid content-center pl-2">{ }</div>
                                        </div>
                                    </button>
                                </div>

                            </div>
                        </form>

                    </>
                }
            />

        </Fragment>
    );
}